import { render, staticRenderFns } from "./ipage.vue?vue&type=template&id=44ff57f5&scoped=true&"
import script from "./ipage.vue?vue&type=script&lang=js&"
export * from "./ipage.vue?vue&type=script&lang=js&"
import style0 from "./ipage.vue?vue&type=style&index=0&id=44ff57f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff57f5",
  null
  
)

export default component.exports